(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ppd-main-product"]) return;
  try {
    
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var field = stepper.querySelector('input');
    if (!field) return;
    stepper.querySelectorAll('[data-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.getAttribute('data-qty-step'), 10) || 0;
        var min = parseInt(field.getAttribute('min'), 10);
        var next = (parseInt(field.value, 10) || 0) + step;
        if (!isNaN(min) && next < min) next = min;
        field.value = next;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Galleries stay still until the visitor explicitly starts playback. */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var status = gallery.querySelector('[data-product-gallery-status]');
    var toggle = gallery.querySelector('[data-gallery-autoplay]');
    var thumbs = gallery.querySelectorAll('[data-ppd-thumb]');
    if (!status || !thumbs.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var currentIndex = 0;

    function sync() {
      if (!toggle) return;
      toggle.classList.toggle('is-running', Boolean(timer));
      toggle.setAttribute('aria-label', timer ? 'Pause the gallery' : 'Play the gallery');
    }

    function start() {
      if (timer || reducedMotion || thumbs.length < 2) return;
      timer = window.setInterval(function () {
        currentIndex = (currentIndex + 1) % thumbs.length;
        thumbs[currentIndex].click();
      }, 5000);
      sync();
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
      sync();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        currentIndex = Number(thumb.getAttribute('data-ppd-thumb')) - 1;
        /* Gallery-lightbox lane: the single polite status stays a plain
           position counter rather than adding a second live region. */
        status.textContent = (currentIndex + 1) + ' / ' + thumbs.length;
        if (timer) { stop(); start(); }
      });
    });

    if (toggle) toggle.addEventListener('click', function () {
      if (timer) stop(); else start();
    });

    gallery.addEventListener('ppd:gallery-pause', stop);

    sync();
  });

  /* Sticky purchase bar: measure the live bar into --sticky-h (page reserve
     + chat FAB offset read the same token) and dock the bar while the
     footer is visible so it never covers footer content. */
  (function () {
    var product = document.querySelector('.ppd-product');
    if (!product) return;
    var bar = product.querySelector('[data-ppd-sticky-cta]');
    if (!bar) return;

    function measure() {
      var height = bar.offsetHeight;
      if (height > 0) {
        product.style.setProperty('--sticky-h', height + 'px');
        document.documentElement.style.setProperty('--sticky-h', height + 'px');
      }
    }

    /* Single owner of both the visual (data-sticky-hidden) and a11y (inert)
       state, so the bar can never end up visible-but-inert or hidden-but-
       focusable. Two independent signals (inline Add-to-cart visibility,
       footer docking) both resolve through here rather than writing the
       attribute directly. The bar is server-rendered visible so phones get
       a working CTA before JS runs; it hides only while the inline button
       is on screen. */
    var inlineOffscreen = false;
    var footerVisible = false;
    function setStickyVisible(visible) {
      bar.setAttribute('data-sticky-hidden', visible ? 'false' : 'true');
      try {
        bar.inert = !visible;
      } catch (e) {}
      measure();
    }

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', measure);
    if ('ResizeObserver' in window) {
      try {
        new ResizeObserver(measure).observe(bar);
      } catch (e) {}
    }

    var footer = document.querySelector('footer[role="contentinfo"]');
    if (footer && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var visible = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          if (visible === footerVisible) return;
          footerVisible = visible;
          setStickyVisible(inlineOffscreen && !footerVisible);
        },
        { threshold: 0 }
      );
      observer.observe(footer);
    }

    var inlineButton = product.querySelector('.ppd-product-form .add-to-bag');
    if (inlineButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          inlineOffscreen = !entry.isIntersecting;
          setStickyVisible(inlineOffscreen && !footerVisible);
        },
        { threshold: 0 }
      ).observe(inlineButton);
    }
  })();

  /* Enlarged gallery view lives in assets/ppd-gallery-lightbox.js (single
     owner). It clones on-page media (no second source of truth), reuses
     <drag-zoom-wrapper> for touch pan/pinch/double-tap 1-5x, and keeps
     focus return, prev/next, backdrop and Escape close. */

  } catch(e) { console.error(e); }
})();
})();
